import { type ReactNode } from "react";
import { X } from "lucide-react";
import { ModalBackdrop } from "@/components/ModalBackdrop";
import { Button } from "@/components/ui/button";
import {
  MODAL_HEADER_ROW_CLASS,
  MODAL_PANEL_CLASS,
  MODAL_PANEL_MAX_HEIGHT_CLASS,
  MODAL_TITLE_CLASS,
} from "@/lib/modalStyles";

type StandardModalProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  panelClassName?: string;
  titleId?: string;
  closeDisabled?: boolean;
};

/**
 * Modal padrão do sistema (referência: Nova promoção).
 * Não fecha ao clicar fora — somente pelo botão X ou ação do conteúdo.
 */
export function StandardModal({
  open,
  title,
  onClose,
  children,
  panelClassName = `max-w-xl ${MODAL_PANEL_MAX_HEIGHT_CLASS}`,
  titleId,
  closeDisabled = false,
}: StandardModalProps) {
  return (
    <ModalBackdrop open={open}>
      <div
        className={`relative flex w-full min-w-0 max-w-full flex-col overflow-y-auto overflow-x-hidden max-sm:min-h-0 max-sm:overflow-hidden ${MODAL_PANEL_CLASS} p-0 ${panelClassName}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={MODAL_HEADER_ROW_CLASS}>
          <h2 id={titleId} className={MODAL_TITLE_CLASS}>
            {title}
          </h2>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-9 w-9 shrink-0"
            aria-label="Fechar"
            onClick={onClose}
            disabled={closeDisabled}
          >
            <X className="h-5 w-5" />
          </Button>
        </div>
        <div className="flex min-h-0 flex-1 flex-col max-sm:overflow-x-hidden max-sm:overflow-y-auto max-sm:overscroll-contain">
          {children}
        </div>
      </div>
    </ModalBackdrop>
  );
}
